import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  mainWrapperWithProjects: {
    flex: 1,
    width: 680,
    alignSelf: 'center',
    marginTop: 30,
  },
  mainWrapperWithoutProjects: { flex: 1 },
  title: {
    color: '#003353',
    fontSize: 32,
    fontWeight: '600',
    lineHeight: 48,
  },
  subtitle: {
    color: '#003353',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
  },
  addProjectBtnWithoutProjects: {
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 220,
    maxHeight: 48,
    position: 'absolute',
    right: 36,
    top: 12,
  },
  addProjectBtnWithProjects: {
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 220,
    maxHeight: 48,
    marginTop: 15,
  },
  addButtonLabel: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    marginRight: 24,
  },
  loadingIndicator: {
    marginTop: 300,
  },
})
